export default __webpack_public_path__ + "static/media/temp-9.c1e72f2e.svg";